export default "/assets/99c2e27190c1ceb5af8db8deb637fea5.png";